var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg7",
    width: 374,
    height: 412,
    viewBox: "-3 -119 374 412",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kopimi",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 41 29 41-29-41-29zm41 29 41 29 41-29-41-29zm41 29 41 29 41-29-41-29zm41 29 41 29 41-29-41-29zm41 29 41 29 41-29-41-29zm-41-87 41 29 41-29-41-29zm82 0 41 29 41-29-41-29zm82 0 41 29 41-29-41-29zm-164-58 41 29 41-29-41-29zm0-58 41 29 41-29-41-29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0v145l205 145v-145zm205 290 41-29v-145l-41 29m-82-174 41-29-41-29zm0 58 41-29-41-29zm41-29 41 29v-58zm0-58 41 29v-58zm0 116 82 58v87l41-29 41 29 41-29v-145l-41 29-41-29-41 29-41-29z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3007fa8d92943d440530eb4697e39f2e.svg";
export { ForwardRef as ReactComponent };